module.exports = __webpack_public_path__ + "img/level_4f.b0c3fcef.png";